
export type VideoQuality = "low" | "medium" | "high" | "very-high";


export const getMediaConstraints = (quality: VideoQuality): MediaStreamConstraints => {
  let targetHeight = 480;
  let targetWidth = 854;
  let targetFrameRate = 30;
  if (quality === "low") {
    targetHeight = 360;
    targetWidth = 640;
    targetFrameRate = 30;
  } else if (quality === "medium") {
    targetHeight = 480;
    targetWidth = 854;
    targetFrameRate = 30;
  } else if (quality === "high") {
    targetHeight = 720;
    targetWidth = 1280;
    targetFrameRate = 30;
  } else if (quality === "very-high") {
    targetHeight = 1080;
    targetWidth = 1920;
    targetFrameRate = 30;
  }
  return {
    video: {width: {ideal: targetWidth}, height: {ideal: targetHeight}, advanced: [{frameRate: {min: targetFrameRate}}, {height: {min: targetHeight}}, {width: {min: targetWidth}}, {frameRate: {max: targetFrameRate}}, {width: {max: targetWidth}}, {height: {max: targetHeight}}, {aspectRatio: {exact: 1.77778}}]},
    audio: {echoCancellation: {ideal: true}, autoGainControl: {ideal: true}, noiseSuppression: {ideal: true}}
  };
};

export const DEFAULT_MAX_BITRATES = {
  camera: {
    audio: 64_000,
    video: 750_000,
  },
  screen: {
    audio: 64_000,
    video: 1_500_000,
  },
} as const;

